module.exports = __webpack_public_path__ + "media/images/file-icons/128/002-tool-014d19f36bc20e1333fda848d81a7458.png";